import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { CurrentUser } from "@/lib/types";

/**
 * Returns the logged-in user. 401/403 is treated as "not signed in"
 * (null user) rather than an error, so route guards can branch
 * cleanly on `user === null`.
 */
export function useCurrentUser() {
  return useQuery<CurrentUser | null>({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        const { data } = await api.get<CurrentUser>("/me/");
        return data;
      } catch (err: unknown) {
        if (
          typeof err === "object" &&
          err !== null &&
          "response" in err &&
          [401, 403].includes((err as { response: { status: number } }).response.status)
        ) {
          return null;
        }
        throw err;
      }
    },
    retry: false,
    staleTime: 60_000,
  });
}
